import hash from 'hash-sum'

const ALERT_DURATION = 5000
const findById = (alerts, id) => alerts.find(alert => alert.id === id)

export const alerts = {
  namespaced: true,
  state: {
    alerts: [],
  },
  mutations: {
    addAlert(state, payload) {
      state.alerts.push(payload)
    },
    removeAlert(state, id) {
      state.alerts = state.alerts.filter(alert => alert.id !== id)
    },
  },
  actions: {
    createAlert({ commit, state }, payload) {
      const {
        id,
        content,
        htmlContent,
        contentKey,
        htmlContentKey,
        htmlContentParams,
        details,
        type = 'success',
        dismissible = true,
        autoHide = false,
      } = payload

      if (
        !['success', 'error', 'info'].includes(type) ||
        (!content && !htmlContent && !contentKey && !htmlContentKey) ||
        (id && findById(state.alerts, id))
      ) {
        return
      }

      const alert = {
        id,
        type,
        dismissible,
        details,
        created: Date.now(),
      }

      if (!alert.id) {
        alert.id = hash(alert)
      }

      if (contentKey) {
        alert.contentKey = contentKey
      } else if (content) {
        alert.content = content
      }

      if (htmlContentKey) {
        alert.htmlContentKey = htmlContentKey
        if (htmlContentParams) alert.htmlContentParams = htmlContentParams
      } else if (htmlContent) {
        alert.htmlContent = htmlContent
      }

      commit('addAlert', alert)

      if (autoHide) {
        setTimeout(() => {
          commit('removeAlert', alert.id)
        }, ALERT_DURATION)
      }
    },
  },
  getters: {
    alertById: state => id => findById(state.alerts, id),
  },
}
